<form [formGroup]="form">
  <div class="row pb-3 pb-lg-5">
    <div class="col-12 pb-3 col-xl-6 pb-xl-0">
      <div class="form-floating">
        <input
          formControlName="name"
          class="form-control"
          id="vertragspartnerInputName"
          type="text"
          [ngClass]="{ 'is-invalid': isInputInvalid('name') }"
        />
        <label for="vertragspartnerInputName">{{ 'meterPoint.meterPointChangeRequest.summary.newPartner.partnerName' | translate }}</label>
        <div class="invalid-feedback">{{ getFormError('name') | translate }}</div>
      </div>
    </div>
    <div class="col-12 col-xl-6">
      <div class="form-floating">
        <input
          formControlName="customerNumber"
          class="form-control"
          id="vertragspartnerInputCustomerNumber"
          type="text"
          [ngClass]="{ 'is-invalid': isInputInvalid('customerNumber') }"
        />
        <label for="vertragspartnerInputCustomerNumber">
          {{ 'meterPoint.meterPointChangeRequest.summary.newPartner.optionalCompanyNr' | translate }}
        </label>
        <div class="invalid-feedback">{{ getFormError('customerNumber') | translate }}</div>
      </div>
    </div>
  </div>
  <div class="row pb-3 pb-lg-5">
    <div class="col-12 pb-3 col-xl-6 pb-xl-0">
      <div class="form-floating">
        <input
          formControlName="uid"
          class="form-control"
          id="vertragspartnerInputUid"
          type="text"
          [ngClass]="{ 'is-invalid': isInputInvalid('uid') }"
        />
        <label for="vertragspartnerInputUid">{{ 'meterPoint.meterPointChangeRequest.summary.newPartner.optionalUid' | translate }}</label>
        <span class="form-text font-12 mt-1">
          <i class="fas fa-info-circle"></i>
          {{ 'meterPoint.meterPointChangeRequest.summary.newPartner.companiesOnly' | translate }}
        </span>
        <div class="invalid-feedback">{{ getFormError('uid') | translate }}</div>
      </div>
    </div>
    <div class="col-12 col-xl-6">
      <div class="form-floating">
        <input
          formControlName="plz"
          class="form-control"
          id="vertragspartnerInputPlz"
          type="text"
          [ngClass]="{ 'is-invalid': isInputInvalid('plz') }"
        />
        <label for="vertragspartnerInputPlz">{{ 'meterPoint.meterPointChangeRequest.summary.newPartner.postalcode' | translate }}</label>
        <div class="invalid-feedback">{{ getFormError('plz') | translate }}</div>
      </div>
    </div>
  </div>
  <div class="row pb-3 pb-lg-5">
    <div class="col-12 pb-3 col-xl-6 pb-xl-0">
      <div class="form-floating">
        <input
          formControlName="city"
          class="form-control"
          id="vertragspartnerInputCity"
          type="text"
          [ngClass]="{ 'is-invalid': isInputInvalid('city') }"
        />
        <label for="vertragspartnerInputCity">{{ 'meterPoint.meterPointChangeRequest.summary.newPartner.city' | translate }}</label>
        <div class="invalid-feedback">{{ getFormError('city') | translate }}</div>
      </div>
    </div>
    <div class="col-12 col-xl-6">
      <div class="form-floating">
        <input
          formControlName="street"
          class="form-control"
          id="vertragspartnerInputStreet"
          type="text"
          [ngClass]="{ 'is-invalid': isInputInvalid('street') }"
        />
        <label for="vertragspartnerInputStreet">{{ 'meterPoint.meterPointChangeRequest.summary.newPartner.street' | translate }}</label>
        <div class="invalid-feedback">{{ getFormError('street') | translate }}</div>
      </div>
    </div>
  </div>
  <div class="row pb-3 pb-lg-5">
    <div class="col-12 pb-3 col-xl-6 pb-xl-0">
      <div class="form-floating">
        <input
          formControlName="houseNumberStaircase"
          class="form-control"
          id="vertragspartnerInputHouseNumber"
          type="text"
          [ngClass]="{ 'is-invalid': isInputInvalid('houseNumberStaircase') }"
        />
        <label for="vertragspartnerInputHouseNumber">{{
          'meterPoint.meterPointChangeRequest.summary.newPartner.housenumber' | translate
        }}</label>
        <div class="invalid-feedback">{{ getFormError('houseNumberStaircase') | translate }}</div>
      </div>
    </div>
    <div class="col-12 col-xl-6">
      <div class="form-floating">
        <input
          formControlName="door"
          class="form-control"
          id="vertragspartnerInputDoor"
          type="text"
          [ngClass]="{ 'is-invalid': isInputInvalid('door') }"
        />
        <label for="vertragspartnerInputDoor">{{ 'meterPoint.meterPointChangeRequest.summary.newPartner.doorOptional' | translate }}</label>
        <div class="invalid-feedback">{{ getFormError('door') | translate }}</div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 pb-3 col-xl-6 pb-xl-0">
      <div class="form-floating">
        <input
          formControlName="phone"
          class="form-control"
          id="vertragspartnerInputPhone"
          type="text"
          [ngClass]="{ 'is-invalid': isInputInvalid('phone') }"
        />
        <label for="vertragspartnerInputPhone">{{
          'meterPoint.meterPointChangeRequest.summary.newPartner.telephoneOptional' | translate
        }}</label>
        <div class="invalid-feedback">{{ getFormError('phone') | translate }}</div>
      </div>
    </div>
    <div class="col-12 col-xl-6">
      <div class="form-floating">
        <input
          formControlName="email"
          class="form-control"
          id="vertragspartnerInputEmail"
          type="email"
          [ngClass]="{ 'is-invalid': isInputInvalid('email') }"
        />
        <label for="vertragspartnerInputEmail">{{
          'meterPoint.meterPointChangeRequest.summary.newPartner.emailOptional' | translate
        }}</label>
        <div class="invalid-feedback">{{ getFormError('email') | translate }}</div>
      </div>
    </div>
  </div>
</form>
